import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface Props {
  children: React.ReactElement | React.ReactElement[]
  selector: string
}

const GroupControlContainer: React.FC<Props> = ({ children, selector }) => {
  const [container, setContainer] = useState<Element | null>(null)

  useEffect(() => {
    const checkElement = setInterval(() => {
      const el = document.querySelector(selector)
      if (el) {
        setContainer(el)
        clearInterval(checkElement)
      }
    }, 100)

    return () => {
      clearInterval(checkElement)
    }
  }, [])

  if (!container) {
    return null
  }

  return createPortal(children, container)
}

export default GroupControlContainer
